import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GtmService } from 'ClientApp/app/shared/cardholders-core/services/gtm.service';
import { ModalService } from 'ClientApp/app/shared/modules/bs-modal/services/modal.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { IContentResponse } from '../../interfaces/IContentResponse.interface';

import { IGetHokDetailsForAllCardResponse } from '../../interfaces/IGetHokDetailsForAllCard.interface';
import { DirectDebitService } from '../../services/direct-debit.service';

import { DebitListService } from './services/main-debit-list.service';
import { a11yFix } from '../../../../shared/utils/a11y.utils';

@Component({
    selector: 'app-main-debit-list',
    templateUrl: './main-debit-list.component.html',
    styleUrls: ['./main-debit-list.component.scss']
})
export class MainDebitListComponent implements OnInit, OnDestroy {
    hoks: IGetHokDetailsForAllCardResponse;
    subs: Subscription[] = [];
    contents: IContentResponse;
    filterOpen: Observable<boolean>;
    constructor(
        private debListSrv: DebitListService,
        private directDebitSrv: DirectDebitService,
        private gtmService: GtmService,
        private modalSrv: ModalService,
        private router: Router,
        private activeRoute: ActivatedRoute
    ) {}
    ngOnDestroy(): void {
        this.subs.forEach((s) => s.unsubscribe());
    }
    ngOnInit(): void {
        this.subs.push(this.directDebitSrv.contents$.subscribe((contents) => (this.contents = contents)));
        this.gtmService.pushDirectDebitList('Screen DirectDebit', 'LOAD');
        this.debListSrv.getHokDetailsForAllCard({ ActiveIndicator: 1 }).subscribe((res) => {
            switch (res.returnCode) {
                case 0:
                    this.hoks = res.result.getHokDetailsForAllCard;
                    this.directDebitSrv.contents$.next(res.result.content);
                    break;

                default:
                    break;
            }
        });
        this.filterOpen = this.debListSrv.filterOpen$.asObservable();

        a11yFix()?.dialog(".debit-details-table .mat-row", {
            selectors: {
                dialog: "modal-container.modal",
                closeBtn: "button.close",
                heading: "h1.ellipsis-one-line",
                trigger: '.debit-details-table .mat-row'
            }
        });
    }
    closeFilter(): void {
        this.debListSrv.filterOpen$.next(false);
    }
    goToDirectDebit(): void {
        this.gtmService.pushDirectDebitList('Get Offer', 'Click');

        this.directDebitSrv.getContent().subscribe((x) => {
            switch (x.returnCode) {
                case 0:
                    this.directDebitSrv.next = 'check-for-card';
                    this.router.navigate(['/direct-debit/personal/check-for-card'], {
                        relativeTo: this.activeRoute
                    });
                    break;
                default:
                    this.directDebitSrv.next = 'error';
                    this.router.navigate(['/direct-debit/personal/error'], { relativeTo: this.activeRoute });
                    break;
            }
        });
    }
}
